export default {
  columnsOrder: [
    'endUserNameLink',
    'customerName',
    'serviceArea',
    'country',
    'status',
    'rebateImage',
  ],
  showFilters: true,
  sortBy: {
    column: 'customerName',
    type: 'descending',
  },
};
